import { ClientConfigProductName } from '@frontend/vanilla/core';

export const SportTreeLoader = {
    id: 'sport-tree',
    loaderFn: () => import(/* webpackChunkName: "ms-sport-tree-widget" */ './sport-tree.feature'),
    product: ClientConfigProductName.SPORTS,
};
